module.exports = __webpack_public_path__ + "static/tone-9ef3dac42045778e908e85d51079f1db.mp3";